import moment from "moment";
import { SocialMediaPlatform } from "./Enums";

export const isSocialAccountExpired = account => {
    const expiryDate = account?.pageAdmin?.expiryDate;
    return Boolean(expiryDate) && moment(expiryDate).isBefore(moment());
};

export const getExpiredSocialPageUuids = (linkedAccounts = {}) => {
    return Object.values(SocialMediaPlatform).flatMap(platform => {
        const accounts = linkedAccounts[platform] || [];
        return accounts
            .filter(isSocialAccountExpired)
            .flatMap(account => account.pages.map(page => page.uuid));
    });
};

export const hasExpiredSocialAccounts = linkedAccounts => {
    return getExpiredSocialPageUuids(linkedAccounts).length > 0;
};
